import { render, staticRenderFns } from "./ProductPromoFilter.vue?vue&type=template&id=0b8ac7d7&scoped=true"
import script from "./ProductPromoFilter.vue?vue&type=script&lang=js"
export * from "./ProductPromoFilter.vue?vue&type=script&lang=js"
import style0 from "./ProductPromoFilter.vue?vue&type=style&index=0&id=0b8ac7d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8ac7d7",
  null
  
)

export default component.exports